import React, { Component } from 'react'
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../hoc/AxiosSetting/axios';
import swal from '@sweetalert/with-react';


export default class OtherStatusComleteForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            statusData: {
                orgCode: 0,
                id: 0,
                orgName: "",
                certificateno: "",
                typeOfCertification: "",
                statusInfo: false,

            },
            certificationlist: []
        }
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.id || 0 };
    }
    postData() {
        console.log("this.state.statusData 26", this.state.statusData)
        axios.patch(APIURL + '/api/othercertstatus/get/othercompanydetails', this.state.statusData)
            .then(res => {
                console.log("res.data 29", res.data)
                if (res.data.errorCode === 0) {
                    console.log("if 32")
                    let tempData = this.state.statusData;
                    tempData.orgCode = res.data.response.orgCode;
                    tempData.orgName = res.data.response.orgName;
                    tempData.certificateno = res.data.response.certificateno;
                    tempData.typeOfCertification = res.data.response.typeOfCertification;
                    tempData.scope = res.data.response.scope;
                    tempData.standard = res.data.response.standard;
                    tempData.address = res.data.response.address;
                    tempData.dateofissue = moment(res.data.response.dateofissue).format("DD-MM-YYYY");
                    tempData.initialcertdate = moment(res.data.response.initialcertdate).format("DD-MM-YYYY");
                    tempData.expirydate = moment(res.data.response.expirydate).format("DD-MM-YYYY");
                    tempData.status = res.data.response.status;
                    tempData.annenxure = res.data.response.annenxure;
                    tempData.statusInfo = true;
                    this.setState({ statusData: tempData })

                } else {
                    swal(res.data.errorMsg, "error");
                }
            })
            .catch(err => {
                swal("Something Went Wrong .. Please Try Again letter!!", "error")
            })


    }
    componentDidMount() {
        axios.get(APIURL + '/api/typeofcertifications/get/typeofcertkeyvaluewithoutselect')
            .then(res => {
                this.setState({ certificationlist: res.data.response })
                console.log("cert", res.data.response)
            })
    }
    onClear(e) {
        let tempData = this.state.statusData;
        tempData.orgCode = "";
        tempData.orgName = "";
        tempData.certificateno = "";
        tempData.typeOfCertification = "";
        tempData.scope = "";
        tempData.standard = "";
        tempData.address = "";
        tempData.dateofissue = "";
        tempData.initialcertdate = "";
        tempData.expirydate = "";
        tempData.status = "";
        tempData.annenxure = "";
        tempData.statusInfo = false;
        this.setState({ statusData: tempData })
    }
    handledetailChange = name => e => {
        const tempData = this.state.statusData;
        tempData[e.target.name] = e.target.value
        this.setState({ statusData: tempData })
    }

    render() {
        const certificationlists = this.state.certificationlist
        let certList = certificationlists.length > 0 && certificationlists.map((item, i) => {
            return (
                <option key={i} value={item.key}>{item.key}</option>
            )
        }, this)
        return (
            <div>
                <div className="content-wrapper" style={{ backgroundColor: "black", height: "1000px" }}>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ padding: "0% 20% 2% 20%" }}>

                                        <div className='text-center' style={{ color: "white", marginTop: "20px" }}>
                                            <h4>Innovative Quality Certification Pvt. Ltd</h4><br />
                                            <h3>Certification Status</h3>
                                        </div>
                                        <div style={{ border: "3px solid #f8f9fa", padding: "2% 5% 5% 5%" }}>
                                            <div className="row mt-4" style={{ color: "white" }}>
                                                <div className="col-sm-4">
                                                    <label>Client Name</label>
                                                </div>
                                                <div className="col-sm-8">
                                                    <input type="text" name="orgName" value={this.state.statusData.orgName} onChange={this.handledetailChange("orgName")} className='form-control' style={{ width: "400px" }} />
                                                </div>
                                            </div>
                                            <div className="row mt-4" style={{ color: "white" }}>
                                                <div className="col-sm-4">
                                                    <label>Certificate No</label>
                                                </div>
                                                <div className="col-sm-8">
                                                    <input type="text" name="certificateno" value={this.state.statusData.certificateno} className='form-control' onChange={this.handledetailChange("certificateno")} style={{ width: "400px" }} />
                                                </div>
                                            </div>
                                            <div className="row mt-4" style={{ color: "white" }}>
                                                <div className='col-sm-4'>
                                                    <label>Type Of Certification</label>
                                                </div>
                                                <div className="col-sm-8" style={{ color: "red" }}>


                                                    <select className="form-control" onChange={this.handledetailChange("typeOfCertification")} name="typeOfCertification" value={this.state.statusData.typeOfCertification} style={{ width: "400px" }}>
                                                        <option value="select">Select</option>
                                                        {certList}
                                                    </select>
                                                    {/* <input type="text" name="typeOfCertification" value={this.state.statusData.typeOfCertification} className='form-control' onChange={this.handledetailChange("typeOfCertification")} style={{width:"400px"}}/> */}
                                                </div>
                                            </div>
                                            <div style={{ display: this.state.statusData.statusInfo === true ? 'block' : 'none' }}>
                                                <div className="row mt-4" style={{ color: "white" }}>
                                                    <div className='col-sm-4'>
                                                        <label>Scope</label>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <input type="text" name="scope" value={this.state.statusData.scope} className='form-control' disabled style={{ width: "400px" }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-4" style={{ color: "white" }}>
                                                    <div className='col-sm-4'>
                                                        <label>Company Address</label>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <input type="text" name="address" value={this.state.statusData.address} className='form-control' disabled style={{ width: "400px" }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-4" style={{ color: "white" }}>
                                                    <div className='col-sm-4'>
                                                        <label>Certificate No</label>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <input type="text" name="certificateno" value={this.state.statusData.certificateno} className='form-control' disabled style={{ width: "400px" }} />
                                                    </div>
                                                </div>

                                                <div className="row mt-4" style={{ color: "white" }}>
                                                    <div className='col-sm-4'>
                                                        <label>Original Registered Date</label>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <input type="text" name="dateofissue" value={this.state.statusData.dateofissue} className='form-control' disabled style={{ width: "400px" }} />
                                                    </div>
                                                </div>
                                                <div className='row mt-4' style={{ color: "white" }}>
                                                    <div className='col-sm-4'>
                                                        <label>Current Issue Date</label>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <input type="text" name="initialcertdate" value={this.state.statusData.initialcertdate} className='form-control' disabled style={{ width: "400px" }} />
                                                    </div>
                                                </div>

                                                <div className="row mt-4" style={{ color: "white" }}>
                                                    <div className='col-sm-4'>
                                                        <label>Expiry Date</label>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <input type="text" name="expirydate" value={this.state.statusData.expirydate} className='form-control' disabled style={{ width: "400px" }} />
                                                    </div>
                                                </div>

                                                <div className="row mt-4" style={{ color: "white" }}>
                                                    <div className='col-sm-4'>
                                                        <label>Status</label>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <input type="text" name="status" value={this.state.statusData.status} className='form-control' disabled style={{ width: "400px" }} />
                                                    </div>
                                                </div>
                                                {

                                                    this.state.statusData.annenxure === "" ?
                                                        ""
                                                        :
                                                        <div className="row mt-4" style={{ color: "white" }}>
                                                            <div className='col-sm-4'>
                                                                <label>Annenxure</label>
                                                            </div>
                                                            <div className="col-sm-8" >
                                                            {/* <p dangerouslySetInnerHTML={{ __html:this.state.data.annenxure}}></p> */}
                                                            {/* <input type="textarea" name="annenxure" value={this.state.statusData.annenxure} className='form-control' disabled style={{ width: "400px"}}/> */}
                                                            <textarea name="annenxure" value={this.state.statusData.annenxure} className='form-control' disabled style={{width:"400px",height:"200px"}}/>


                                                            </div>



                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>

                    </section>
                    <div className="row mt-4" style={{ color: "white" }}>
                        <div className="col-sm-4" />
                        <div className="col-sm-3">
                            <button type="submit" className="btn btn-primary float-right" onClick={() => this.postData()}>Show Status</button>

                        </div>
                        <div className="col-sm-4">

                            <button type="submit" className="btn btn-primary float-left" onClick={() => this.onClear()}>Reset</button>

                        </div>


                    </div>
                </div>


            </div>

        )
    }

}